'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexContentLayout = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _card = require('antd/lib/card');

var _card2 = _interopRequireDefault(_card);

var _affix = require('antd/lib/affix');

var _affix2 = _interopRequireDefault(_affix);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _reactRouter = require('react-router');

var _breadCrumb = require('../../components/breadCrumb');

var _globalFooter = require('../../components/globalFooter');

var _basicLayout = require('../basicLayout');

var _Drawer = require('material-ui/Drawer');

var _Drawer2 = _interopRequireDefault(_Drawer);

var _Divider = require('material-ui/Divider');

var _Divider2 = _interopRequireDefault(_Divider);

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  root: {
    flexGrow: 1
  },
  appFrame: {
    minHeight: '100%',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    width: '100%'
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 20
  },
  hide: {
    display: 'none'
  },
  drawerPaper: {
    position: 'relative'
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px'
  },
  drawerHeaderRight: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px'
  },
  content: {
    flexGrow: 1,
    padding: 0
  },
  'contentShift-left': {
    marginLeft: 0
  },
  'contentShift-right': {
    marginRight: 0
  },
  iconSelected: {
    color: '#00bfdc',
    background: '#e6f7ff',
    boxShadow: '-1px -1px 1px #c5dff5'
  },
  title: {
    height: 30,
    width: '100%',
    lineHeight: '30px',
    paddingLeft: '10px',
    whiteSpace: 'nowrap',
    wordBreak: 'break-all',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  }
};
var FlexContentLayout = exports.FlexContentLayout = (_temp = _class = function (_BasicLayout) {
  _inherits(FlexContentLayout, _BasicLayout);

  function FlexContentLayout(props) {
    _classCallCheck(this, FlexContentLayout);

    var _this = _possibleConstructorReturn(this, (FlexContentLayout.__proto__ || Object.getPrototypeOf(FlexContentLayout)).call(this, props));

    _this.handleLeftDrawer = function (open) {
      if (open === false) {
        _this.setState({ openLeft: false });
      } else {
        _this.setState({ openLeft: !_this.state.openLeft }); // openProcessor: false
      }
    };

    _this.handleRightDrawer = function (open) {
      if (open === false) {
        _this.setState({ openRight: false });
      } else {
        _this.setState({ openRight: !_this.state.openRight });
      }
    };

    _this.handleRightDrawerClose = function () {
      _this.setState({ openRight: false });
    };

    var drawerStyle = Object.assign({ zIndex: _this.props.zIndex || 1000 }, props.drawerStyle);
    _this.state = {
      openLeft: !!_this.props.openLeft,
      openRight: !!_this.props.openRight,
      drawerStyle: drawerStyle
    };
    return _this;
  }

  _createClass(FlexContentLayout, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var Footer = this.getComponent('Footer');
      var BLink = this.getComponent('Link');
      var BreadCrumb = this.getComponent('BreadCrumb');

      var LeftDrawer = this.getComponent('LeftDrawer');
      var RightDrawer = this.getComponent('RightDrawer');
      var Overview = this.getComponent('Overview');
      var Combox = this.getComponent('Combox');
      var _props = this.props,
          className = _props.className,
          drawerWidth = _props.drawerWidth,
          overviewWidth = _props.overviewWidth,
          leftTitle = _props.leftTitle,
          rightTitle = _props.rightTitle,
          affix = _props.affix,
          style = _props.style,
          mainStyle = _props.mainStyle;
      var _state = this.state,
          drawerStyle = _state.drawerStyle,
          openLeft = _state.openLeft,
          openRight = _state.openRight;

      var hasOverview = this.hasComponent('Overview');
      var hasLeftDrawer = this.hasComponent('LeftDrawer');
      var hasRightDrawer = this.hasComponent('RightDrawer');

      var StepConnector = this.getComponent('StepConnector');
      var hasStepConnector = this.hasComponent('StepConnector');

      var beforeDrawer = hasLeftDrawer ? _react2.default.createElement(
        _Drawer2.default,
        {
          open: openLeft,
          style: styles.drawerPaper,
          width: drawerWidth,
          containerStyle: drawerStyle
        },
        _react2.default.createElement(
          'div',
          { style: styles.drawerHeader },
          _react2.default.createElement(
            'div',
            { style: styles.title },
            leftTitle
          ),
          _react2.default.createElement(_icon2.default, { type: 'left-square-o', onClick: function onClick() {
              return _this2.handleLeftDrawer(false);
            } })
        ),
        _react2.default.createElement(_Divider2.default, null),
        _react2.default.createElement(LeftDrawer, { Link: BLink })
      ) : null;
      var afterDrawer = hasRightDrawer ? _react2.default.createElement(
        _Drawer2.default,
        {
          openSecondary: true,
          open: openRight,
          style: styles.drawerPaper,
          width: drawerWidth,
          containerStyle: drawerStyle
        },
        _react2.default.createElement(
          'div',
          { style: styles.drawerHeaderRight },
          _react2.default.createElement(_icon2.default, { type: 'right-square-o', onClick: function onClick() {
              return _this2.handleRightDrawer(false);
            } }),
          _react2.default.createElement(
            'div',
            { style: styles.title },
            rightTitle
          )
        ),
        _react2.default.createElement(_Divider2.default, null),
        _react2.default.createElement(RightDrawer, { Link: BLink })
      ) : null;
      var Head = _react2.default.createElement(
        'div',
        { className: 'j-elem-iconbox' },
        hasLeftDrawer ? _react2.default.createElement(_icon2.default, { type: 'compass', onClick: this.handleLeftDrawer, style: openLeft ? styles.iconSelected : {} }) : null,
        hasRightDrawer ? _react2.default.createElement(_icon2.default, { type: 'appstore-o', onClick: this.handleRightDrawer, style: openRight ? styles.iconSelected : {} }) : null,
        hasStepConnector ? _react2.default.createElement(
          'div',
          { className: 'j-step-connector' },
          _react2.default.createElement(StepConnector, null)
        ) : null,
        _react2.default.createElement(BreadCrumb, { Link: BLink, style: { marginLeft: hasLeftDrawer ? 35 : 0, marginRight: hasRightDrawer ? 35 : 0 } })
      );
      return _react2.default.createElement(
        'div',
        { className: 'j-layout-flexContent ' + className, style: Object.assign(style, styles.root) },
        affix ? _react2.default.createElement(
          _affix2.default,
          null,
          Head
        ) : Head,
        _react2.default.createElement(
          'div',
          { style: styles.appFrame },
          beforeDrawer,
          _react2.default.createElement(
            'main',
            {
              style: Object.assign({
                minHeight: document.body.offsetHeight - 107
              }, styles.content, mainStyle, openLeft ? { marginLeft: drawerWidth } : styles['contentShift-left'], openRight ? { marginRight: drawerWidth } : styles['contentShift-right'])
            },
            _react2.default.createElement('div', { style: styles.drawerHeader }),
            _react2.default.createElement(
              _card2.default,
              { bordered: false, className: 'j-content', style: this.props.contentStyle },
              _react2.default.createElement(
                'div',
                { className: 'j-content-wrap', style: { width: hasOverview ? 'calc(100% - ' + overviewWidth + 'px)' : '' } },
                this.props.viewContent || this.props.children
              ),
              _react2.default.createElement(
                'div',
                { className: 'j-content-overview', style: { flexBasis: overviewWidth, display: hasOverview ? '' : 'none' } },
                _react2.default.createElement(Overview, null)
              )
            ),
            _react2.default.createElement(Combox, null),
            _react2.default.createElement(Footer, { className: 'j-footer' })
          ),
          afterDrawer
        )
      );
    }
  }]);

  return FlexContentLayout;
}(_basicLayout.BasicLayout), _class.displayName = 'FlexContentLayout', _class.layoutBlocks = {
  Footer: _globalFooter.GlobalFooter,
  Link: _reactRouter.Link,
  BreadCrumb: _breadCrumb.BreadCrumb
}, _class.propTypes = {
  className: _propTypes2.default.string,
  leftTitle: _propTypes2.default.node,
  rightTitle: _propTypes2.default.node,
  drawerStyle: _propTypes2.default.object,
  openLeft: _propTypes2.default.bool,
  openRight: _propTypes2.default.bool,
  hasSider: _propTypes2.default.bool,
  drawerWidth: _propTypes2.default.number,
  zIndex: _propTypes2.default.number,
  affix: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  mainStyle: _propTypes2.default.object,
  contentStyle: _propTypes2.default.object
}, _class.defaultProps = {
  drawerWidth: 200,
  overviewWidth: 250,
  affix: true,
  style: {},
  mainStyle: {}
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/layouts/flexContentLayout/index.jsx
// module id = 53
// module chunks = 0